import React from "react";
function NavDrawer({ isOpen, placement, children, cls }) {
  const placementProps =
    placement === "top"
      ? `w-full top-[87px] ${
          isOpen ? "bottom-0" : "bottom-[calc(100% - 87px)]"
        }`
      : `${isOpen ? "w-full" : "w-0"} bottom-0`;
  return (
    <div
      className={`fixed left-0 top-[87px] z-[999] h-[calc(100vh-87px)] bg-primary-500 transition-all duration-200 ease-linear ${cls} ${placementProps}`}
    >
      {isOpen && children}
    </div>
  );
}

export default React.memo(NavDrawer);
